<template>



    <div class="w1200 audition-page">



        <div class="audition-type">



            <div class="desc">提交万元实战方案</div>



            <div class="actions">



                <span class="apply_sss" @click="goBack">返回栏目</span>



            </div>



        </div>







        <el-alert



            v-if="!period"



            title="当前无进行中的海选期次，暂无法提交"



            type="warning"



            show-icon



            :closable="false"



            style="margin-bottom:16px;" />







        <period-summary v-if="period" :period="period" :lottery-options="lotteryOptions" />

        <el-alert
            v-if="period"
            type="info"
            show-icon
            :closable="false"
            style="margin-bottom:16px;">
            <template slot="title">
                仅支持双色球红球 / 大乐透前区参与计分。命中积分：双色球 6/5/4/3 个对应二等奖金额/200/10/5；大乐透前区 5/4/3/2 个对应二等奖金额/200/10/5。排名按往期累计，多组红表/前区条件取最大命中数。
            </template>
        </el-alert>

        <div class="audition-detail-panel">



            <el-form ref="form" :model="form" :rules="rules" label-width="120px" :disabled="!period">



                <el-form-item label="方案名称" prop="title">



                    <el-input v-model="form.title" placeholder="请输入方案名称" maxlength="256" />



                </el-form-item>



                <el-form-item label="彩种" prop="preType">



                    <el-select
                        v-model="form.preType"
                        placeholder="请选择彩种"
                        style="width:100%"
                        :disabled="!!routePreType">



                        <el-option



                            v-for="item in filteredLotteryOptions"



                            :key="item.dictValue"



                            :label="item.dictLabel"



                            :value="item.dictValue" />



                    </el-select>



                </el-form-item>



                <el-form-item label="预测期号" prop="issueNumber">



                    <el-input v-model="form.issueNumber" placeholder="系统自动带出下期期号" :disabled="!!period && !!period.targetIssueNumber" />



                </el-form-item>



                <el-form-item label="注数" prop="betCount">



                    <el-input-number v-model="form.betCount" :min="1" :step="1" disabled />



                    <span class="amount-hint" :class="amountValid ? 'valid' : 'invalid'">



                        当前金额约 {{ betAmount }} 元（须 {{ period ? period.amountMin : '-' }} ~ {{ period ? period.amountMax : '-' }} 元）



                    </span>



                </el-form-item>



                <el-form-item label="投注文件" prop="attachmentId">



                    <div class="upload-section">



                        <div class="upload-actions">



                            <label class="upload-btn">



                                <el-button size="small" type="primary" plain :loading="uploadingTxt">选择 TXT</el-button>



                                <input



                                    ref="txtInput"



                                    type="file"



                                    accept=".txt"



                                    style="display:none"



                                    @change="handleUpload($event)" />



                            </label>



                            <el-button v-if="uploadFileName" type="text" size="small" @click="clearUpload">清除文件</el-button>



                        </div>



                        <div v-if="uploadFileName" class="upload-file-name">已选：{{ uploadFileName }}</div>



                        <div class="upload-tip">请上传仅含红球/前区的 TXT 投注文件，系统将自动统计注数。</div>



                    </div>



                </el-form-item>



                <el-form-item label="预期收益分析">



                    <el-input v-model="form.profitAnalysis" type="textarea" :rows="2" />



                </el-form-item>



                <el-form-item label="预期奖金">



                    <el-input-number v-model="form.expectedPrize" :min="0" :precision="2" />



                </el-form-item>



                <el-form-item>



                    <el-button type="primary" :disabled="!period || !amountValid || !form.attachmentId" @click="submitForm">提交方案</el-button>



                </el-form-item>



            </el-form>



        </div>



    </div>



</template>







<script>



import { getCurrentPeriod, submitEntry } from '@/api/audition'



import { queryLotteryType, queryUuIdInfo, upLoadFile } from '@/api/common'



import PeriodSummary from './components/PeriodSummary.vue'

import { filterAuditionLotteryOptions, hxwyszHomeLocation, ALLOWED_PRE_TYPES } from './utils'







const FILE_TYPE = 'audition_bet_file'







export default {



    components: { PeriodSummary },



    data () {



        return {



            period: null,



            lotteryOptions: [],



            uploadBizId: '',



            uploadFileName: '',



            uploadingTxt: false,



            form: {



                title: '',



                preType: '',



                issueNumber: '',



                betContent: '',



                profitAnalysis: '',



                betCount: 4750,



                expectedPrize: undefined,



                attachmentId: ''



            },



            rules: {



                title: [{ required: true, message: '请输入方案名称', trigger: 'blur' }],



                preType: [{ required: true, message: '请选择彩种', trigger: 'change' }],



                attachmentId: [{ required: true, message: '请上传 TXT 投注文件', trigger: 'change' }],



                betCount: [{ required: true, message: '请上传 TXT 文件以统计注数', trigger: 'blur' }]



            }



        }



    },



    computed: {



        routePreType () {



            return this.$route.query.preType || ''



        },



        filteredLotteryOptions () {

            const base = !this.period || !this.period.lotteryTypes || !this.period.lotteryTypes.length
                ? this.lotteryOptions
                : this.lotteryOptions.filter(o => this.period.lotteryTypes.includes(o.dictValue))
            return filterAuditionLotteryOptions(base)

        },



        betAmount () {



            return (this.form.betCount || 0) * 2



        },



        amountValid () {



            if (!this.period) return false



            const min = Number(this.period.amountMin)



            const max = Number(this.period.amountMax)



            return this.betAmount >= min && this.betAmount <= max



        }



    },



    watch: {



        'form.preType' (val) {



            if (val) {



                this.loadPeriod(val)



            }



        }



    },



    mounted () {



        if (!this.vuex_token) {



            this.$router.replace('/login?redirect=' + encodeURIComponent('/hxwysz/submit'))



            return



        }



        Promise.all([



            queryLotteryType().then(res => {



                if (res.code === 200) this.lotteryOptions = filterAuditionLotteryOptions(res.data)



            }),



            queryUuIdInfo().then(id => { this.uploadBizId = id }),



            this.loadPeriod()



        ])



    },



    methods: {



        goBack () {

            this.$router.push(hxwyszHomeLocation(this.form.preType || this.routePreType))

        },



        loadPeriod (preType) {



            const type = preType || this.routePreType || this.form.preType || undefined



            return getCurrentPeriod(type).then(res => {



                if (res.code === 200 && res.data) {



                    this.period = res.data



                    if (res.data.targetIssueNumber) {



                        this.form.issueNumber = res.data.targetIssueNumber



                    }



                    this.$nextTick(() => {



                        if (type) {



                            this.form.preType = type



                        } else if (this.filteredLotteryOptions.length === 1) {



                            this.form.preType = this.filteredLotteryOptions[0].dictValue



                        }



                    })



                } else {



                    this.period = null



                }



            })



        },



        async handleUpload (event) {



            const file = event.target.files && event.target.files[0]



            event.target.value = ''



            if (!file) return



            if (!this.uploadBizId) {



                this.uploadBizId = await queryUuIdInfo()



            }



            const loadingKey = 'uploadingTxt'



            this[loadingKey] = true



            const formData = new FormData()



            formData.append('file', file)



            const params = new URLSearchParams({



                bizId: this.uploadBizId,



                fileType: FILE_TYPE,



                number: this.form.issueNumber || ''



            }).toString()



            upLoadFile('?' + params, formData).then(res => {



                if (res.code === 200 && res.data) {



                    this.form.attachmentId = res.data.fileId



                    this.uploadFileName = file.name



                    const countKey = `${this.uploadBizId}_AUDITION_BET_FILE`



                    const lineCount = Number(res.data[countKey])



                    if (lineCount > 0) {



                        this.form.betCount = lineCount



                    }



                    this.$refs.form && this.$refs.form.validateField('attachmentId')



                    this.$message.success('文件上传成功')



                } else {



                    this.$message.error(res.msg || '上传失败')



                }



                this[loadingKey] = false



            }).catch(() => {



                this.$message.error('上传失败')



                this[loadingKey] = false



            })



        },



        clearUpload () {



            this.form.attachmentId = ''



            this.form.betCount = 4750



            this.uploadFileName = ''



            this.$refs.form && this.$refs.form.validateField('attachmentId')



        },



        submitForm () {



            if (!this.amountValid) {



                this.$message.warning('投注金额须在期次规定区间内')



                return



            }



            this.$refs.form.validate(valid => {



                if (!valid) return



                const payload = Object.assign({}, this.form, { periodId: this.period.id })



                submitEntry(payload).then(res => {



                    if (res.code === 200) {



                        this.$message.success((res.header && res.header.msg) || res.msg || '提交成功，待审核')



                        const preType = this.form.preType || this.routePreType
                        const query = {}
                        if (preType != null && preType !== '' && ALLOWED_PRE_TYPES.includes(String(preType))) {
                            query.preType = String(preType)
                        }
                        this.$router.push({ path: '/hxwysz/list', query })



                    } else {



                        this.$message.error(res.msg || '提交失败')



                    }



                })



            })



        }



    }



}



</script>







<style lang="scss" scoped>



@import "./audition.scss";



.amount-hint {



    margin-left: 12px;



    font-size: 13px;



    &.valid { color: #67c23a; }



    &.invalid { color: #f56c6c; }



}



.upload-section {



    margin-top: 12px;



    padding-top: 12px;



    border-top: 1px dashed #dcdfe6;



}



.upload-divider {



    font-size: 13px;



    color: #909399;



    margin-bottom: 10px;



}



.upload-actions {



    display: flex;



    align-items: center;



    flex-wrap: wrap;



    gap: 10px;



}



.upload-btn {



    cursor: pointer;



}



.upload-file-name {



    margin-top: 8px;



    font-size: 13px;



    color: #409eff;



}



.upload-tip {



    margin-top: 8px;



    font-size: 12px;



    color: #909399;



}



</style>





